import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-axelia-bg">
      <Navbar />

      <main className="pt-24 md:pt-32 pb-20 md:pb-28">
        <div className="w-full px-6 md:px-10 lg:px-16 max-w-3xl mx-auto">
          {/* Breadcrumb */}
          <nav className="mb-8">
            <ol className="flex items-center gap-2 text-sm text-axelia-text-muted">
              <li>
                <Link to="/" className="hover:text-axelia-accent transition-colors">
                  トップページ
                </Link>
              </li>
              <li>
                <span className="w-1 h-1 rounded-full bg-axelia-text-muted" />
              </li>
              <li className="text-axelia-text">プライバシーポリシー</li>
            </ol>
          </nav>

          <h1 className="font-serif text-2xl md:text-3xl font-bold text-axelia-text mb-10">
            プライバシーポリシー
          </h1>

          <div className="space-y-8">
            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                1. 基本方針
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                AXELIA株式会社（以下「当社」といいます。）は、個人情報の重要性を認識し、
                個人情報保護法及び関連法令を遵守するとともに、個人情報の適正な取り扱いと保護に努めます。
                当社は、お客様からお預かりした個人情報を適切に管理し、プライバシーの保護に万全を尽くします。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                2. 個人情報の定義
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                個人情報とは、個人情報保護法にいう「個人情報」を指し、生存する個人に関する情報であって、
                当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報、
                および個人識別符号が含まれる情報を指します。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                3. 個人情報の収集方法
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                当社は、お問い合わせフォーム、メール、その他の方法でお客様から個人情報を収集する場合があります。
                収集する情報には、氏名、会社名、メールアドレス、電話番号、住所、お問い合わせ内容等が含まれます。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                4. 個人情報の利用目的
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9] mb-3">
                当社は、収集した個人情報を以下の目的のために利用します。
              </p>
              <ul className="text-sm md:text-base text-axelia-text-secondary leading-[1.9] list-disc pl-5 space-y-1">
                <li>お客様からのお問い合わせに対する回答および連絡</li>
                <li>当社サービスのご案内および資料送付</li>
                <li>当社サービスの改善および新サービスの開発</li>
                <li>ニュースレター等の配信</li>
                <li>お客様との契約履行および履行に必要な管理</li>
                <li>法令等に基づく対応</li>
              </ul>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                5. 個人情報の第三者提供
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                当社は、法令に基づく場合を除き、お客様の同意なく第三者に個人情報を提供することはありません。
                ただし、業務委託先に対して、必要な範囲内で個人情報を預託する場合があります。
                この場合、当社は委託先に対して適切な監督を行います。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                6. 個人情報の安全管理
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                当社は、個人情報の漏えい、滅失、毀損等を防ぐため、
                組織的・人的・物理的・技術的な安全対策を講じ、
                個人情報の適切な管理に努めます。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                7. 個人情報の開示・訂正・削除
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                お客様ご本人からの個人情報の開示、訂正、追加、削除、利用停止等のご請求があった場合、
                ご本人であることを確認の上、法令に従い適切に対応いたします。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                8. Cookieの使用
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                当社のウェブサイトでは、ユーザーエクスペリエンスの向上やアクセス解析のため、
                Cookieを使用する場合があります。お客様はブラウザの設定でCookieを無効化できますが、
                一部の機能が利用できなくなる場合があります。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                9. プライバシーポリシーの変更
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                当社は、必要に応じて本ポリシーの内容を変更することがあります。
                変更後の内容は、当社ウェブサイトに掲載した時点で効力を生じるものとします。
              </p>
            </section>

            <section>
              <h2 className="font-serif text-lg font-bold text-axelia-text mb-3">
                10. お問い合わせ
              </h2>
              <p className="text-sm md:text-base text-axelia-text-secondary leading-[1.9]">
                個人情報の取り扱いに関するお問い合わせは、以下の連絡先までお願いいたします。
              </p>
              <div className="mt-4 bg-axelia-bg-warm rounded-xl p-5">
                <p className="text-sm font-medium text-axelia-text mb-1">AXELIA株式会社</p>
                <p className="text-sm text-axelia-text-secondary">
                  〒104-0041 東京都中央区八丁堀3丁目15番6-509号
                </p>
                <p className="text-sm text-axelia-text-secondary mt-1">
                  代表者：松葉 崇紘
                </p>
                <p className="text-sm text-axelia-text-secondary mt-1 break-all">
                  メール：customer@axelia-tech.com
                </p>
                <p className="text-sm text-axelia-text-secondary mt-1">
                  電話：03-6821-7456
                </p>
              </div>
            </section>
          </div>

          <div className="mt-12 pt-6 border-t border-axelia-bg-warm">
            <p className="text-xs text-axelia-text-muted">
              制定日：2026年5月14日
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
